// extracted by mini-css-extract-plugin
module.exports = {"withBorderRadius":"bordered-banner_withBorderRadius__mdNKR","withBorderRadius--tgbm7":"bordered-banner_withBorderRadius--tgbm7__Nzkmo"};